import React from "react"
import { useQuery } from "@apollo/client"
import PrimaryButton from "../../Ui/Buttons/PrimaryButton"
import { Loader } from "../../Ui/Loader"
import GET_INCOMING_STOCK from "../../../graphql/queries/incomingStock/GetIncomingStock"
import {
  Blur,
  ButtonWrapper,
  Container,
  ErrorText,
  IncomingStockItem,
  LoadingWrapper,
  StockGrid,
  StockItem,
  VariantId
} from "./IncomingStockPopup.styled"
import { IncomingStock } from "lib/types/generated/graphql-types"
import dayjs from "dayjs"

type Props = {
  productVariantId: string
  displayName?: string
  onClose: () => void
}

const IncomingStockPopup = ({ productVariantId, displayName, onClose }: Props) => {
  const { data, loading, error } = useQuery(GET_INCOMING_STOCK, {
    variables: { productVariantId },
    fetchPolicy: "network-only"
  })

  const stockData: IncomingStock[] = data?.getIncomingStock

  const recentStockDataList = stockData
    ?.filter((stock) => !!stock.incomingStockDate)
    ?.filter((stock) => dayjs(stock.incomingStockDate).isAfter(dayjs()))
    ?.sort((a, b) => dayjs(a.incomingStockDate).valueOf() - dayjs(b.incomingStockDate).valueOf())

  const recentStock = recentStockDataList?.length > 0 ? recentStockDataList[0] : undefined

  return (
    <div>
      <Blur onClick={onClose} />
      <Container>
        <h2>Incoming Stock Info</h2>
        {displayName && <VariantId>{displayName}</VariantId>}
        <VariantId>Variant ID: {productVariantId}</VariantId>

        {loading && (
          <LoadingWrapper>
            <Loader color="#333" />
          </LoadingWrapper>
        )}

        {error && <ErrorText>{error.message}</ErrorText>}

        {!loading && !error && stockData && (
          <StockGrid>
            <StockItem>
              <h4>Current Stock</h4>
              <span>{recentStock?.quantity ?? "N/A"}</span>
            </StockItem>
            <StockItem>
              <h4>Incoming Quantity</h4>
              <span>{recentStock?.incomingStockQuantity ?? "N/A"}</span>
            </StockItem>
            <IncomingStockItem>
              <h4>Has Incoming Stock</h4>
              <span>{(recentStock?.incomingStockQuantity ?? 0) > 0 ? "Yes" : "No"}</span>
            </IncomingStockItem>
          </StockGrid>
        )}

        {!loading && !error && !stockData && (
          <ErrorText>No stock data found for this variant</ErrorText>
        )}

        <ButtonWrapper>
          <PrimaryButton handleClick={onClose}>Close</PrimaryButton>
        </ButtonWrapper>
      </Container>
    </div>
  )
}

export default IncomingStockPopup
